import React from 'react';
import { DocumentIcon } from './icons/DocumentIcon';
const materials = ['Manual completo de Hydra Gloss Lips', 'Guía de práctica paso a paso', 'Capacitación completa en labios', 'Curso de micropigmentación de labios', 'Manual de micropigmentación', 'Manual de actividades de micropigmentación labial', 'Lip Blush Workbook', 'Guía completa de colorimetría en labios', 'Presentación profesional de labios y cejas', 'Material Glow Power', 'Guía de cuidados en casa para clientas', 'Guía de cuidados post micropigmentación', 'Formulario de consulta y consentimiento profesional', 'Listado de materiales y proveedores', 'Consejos profesionales para mejores resultados'];
export function PDFLibrary() {
  return <section className="py-12 px-4 bg-[#FDFBF7]" data-id="element-195">
      <div className="max-w-6xl mx-auto" data-id="element-196">
        <div className="text-center mb-10 space-y-3" data-id="element-197">
          <div className="inline-flex items-center gap-2 text-[#E5A5A0] mb-1" data-id="element-198">
            <DocumentIcon className="w-5 h-5" data-id="element-199" />
          </div>
          <h2 className="text-2xl md:text-3xl font-semibold text-[#3D3028]" data-id="element-200">
            + BIBLIOTECA COMPLETA DE MATERIAL PROFESIONAL
          </h2>
          <p className="text-sm md:text-base text-[#3D3028]/70 max-w-2xl mx-auto" data-id="element-201">
            Además de los videos, recibís material descargable exclusivo para
            que no improvises nunca más.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-202">
          {materials.map((item, index) => <div key={index} className="flex items-center gap-3 p-5 rounded-xl bg-white border border-[#D4C4B0]/20" data-id="element-203">
              <div className="bg-[#FAF8F4] p-2.5 rounded-lg text-[#E5A5A0] flex-shrink-0" data-id="element-204">
                <DocumentIcon className="w-4 h-4" data-id="element-205" />
              </div>
              <span className="text-[#3D3028]/80 font-medium text-xs leading-tight" data-id="element-206">
                {item}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}